import NavbarPlaceholder from '../components/NavbarPlaceholder';
import PostcodeInput from '../components/PostcodeInput';
import TrustpilotNumberOne from '../components/TrustpilotNumberOne';
import useDeviceSize, { MD_BREAKPOINT } from '../hooks/useDeviceSize';

const EnterPostcode = () => {
    const { width, height, isMobile } = useDeviceSize();

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <NavbarPlaceholder />
            <div
                style={{
                    display: 'flex',
                    flexDirection: isMobile ? 'column' : 'row',
                    position: 'relative',
                    width: '100%',
                    height: isMobile ? '150vh' : '100vh',
                    margin: 0,
                    padding: 0,
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        position: isMobile ? 'inherit' : 'absolute',
                        left: 0,
                        top: 0,
                        width: isMobile ? '100%' : '40%',
                        height: isMobile ? 'auto' : '100%',
                        paddingLeft: isMobile ? '1rem' : '2rem',
                        paddingRight: isMobile ? '1rem' : 0,
                        paddingTop: isMobile ? '2rem' : width < MD_BREAKPOINT ? '6rem' : '8rem',
                        paddingBottom: isMobile ? '2rem' : width < MD_BREAKPOINT ? '6rem' : '8rem',
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: '100%',
                            height: '100%',
                            position: 'relative',
                            justifyContent: 'space-between',
                        }}
                    >
                        <div>
                            <div>
                                <h1
                                    style={{
                                        fontFamily: 'Montserrat',
                                        fontWeight: 600,
                                        fontSize: width < MD_BREAKPOINT ? '28px' : '36px',
                                        lineHeight: 1.5,
                                    }}
                                >
                                    <span
                                        style={{
                                            background: 'linear-gradient(90deg, rgb(59 179 73) 0%, rgb(52 234 68) 39.55%) text',
                                            // Make compatible with other browsers too
                                            backgroundImage: 'linear-gradient(90deg, rgb(59 179 73) 0%, rgb(52 234 68) 39.55%)',
                                            WebkitBackgroundClip: 'text',
                                            WebkitTextFillColor: 'transparent',
                                            backgroundClip: 'text',
                                            color: 'transparent',

                                        }}
                                    >
                                        Solar Panels -
                                    </span>{' '}
                                    Save £1000s on your electricity bill
                                </h1>

                                <h3
                                    style={{
                                        marginTop: '2rem',
                                        fontWeight: '400',
                                        fontSize: width < MD_BREAKPOINT ? '16px' : '18px',
                                    }}
                                >
                                    Join thousands of local households who have slashed their energy spending. Enter your postcode for a free quote.
                                </h3>
                            </div>

                            <div
                                style={{
                                    position: 'relative',
                                    marginTop: '3rem',
                                }}
                            >
                                <PostcodeInput />
                            </div>
                        </div>

                        {!isMobile && (
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    position: 'relative',
                                }}
                            >
                                <TrustpilotNumberOne />
                            </div>
                        )}
                    </div>
                </div>

                <div
                    style={{
                        flex: 1,
                        display: 'flex',
                        position: isMobile ? 'inherit' : 'absolute',
                        right: 0,
                        top: 0,
                        width: isMobile ? '100%' : '66%',
                        height: isMobile ? 'auto' : '100%',
                    }}
                >
                    <img
                        width={isMobile ? '100%' : 'auto'}
                        height={isMobile ? 'auto' : '100%'}
                        src='https://storage.googleapis.com/ebc-solar-quotation-widget/assets/C0851.00_00_34_10.Still012.jpg'
                        alt='Solar Panels'
                        style={{
                            width: '100%',
                            height: '100%',
                            position: 'absolute',
                            right: 0,
                            top: 0,
                            WebkitClipPath: isMobile ? 'none' : 'polygon(25% 0, 100% 0, 100% 100%, 0% 100%)',
                            clipPath: isMobile ? 'none' : 'polygon(25% 0, 100% 0, 100% 100%, 0% 100%)',
                            objectFit: 'cover',
                        }}
                    />
                </div>

                {isMobile && (
                    <div
                        style={{
                            width: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            position: 'fixed',
                            bottom: '0',
                            marginBottom: '2rem',
                            alignItems: 'center',
                        }}
                    >
                        <TrustpilotNumberOne />
                    </div>
                )}
            </div>
        </div>
    );
};

export default EnterPostcode;
